var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Overall",
    role: "img",
    viewBox: "0 0 100 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Overall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2926,68.3765L59.8231,5.5127c-3.3316-5.446-10.4226-7.1449-15.8381-3.7946 c-1.536,0.9502-2.8285,2.25-3.7734,3.7946L1.7421,68.3765c-2.2306,3.5598-2.3258,8.0669-0.2475,11.7187 c2.0314,3.6614,5.8812,5.9232,10.0504,5.9046h76.9445C94.851,85.9955,100.0044,80.806,100,74.4089 c-0.0015-2.14-0.5925-4.2378-1.7074-6.0607 M52.6017,65.7353c-0.1349,0.3451-0.3465,0.6547-0.6187,0.9049 c-1.0339,1.0933-2.7533,1.1367-3.8405,0.097c-0.033-0.0315-0.0651-0.0639-0.0965-0.097c-0.2738-0.2488-0.4857-0.5587-0.6187-0.9049 c-0.1549-0.3364-0.2318-0.7039-0.225-1.0746c-0.0125-0.3712,0.0647-0.74,0.225-1.0746c0.1313-0.3634,0.3428-0.6922,0.6187-0.9615 c1.1063-1.0458,2.8307-1.0458,3.9369,0c0.2741,0.2708,0.4853,0.5991,0.6187,0.9615c0.1603,0.3346,0.2375,0.7034,0.225,1.0746 C52.8335,65.0314,52.7566,65.3988,52.6017,65.7353 M52.8323,53.1003c0,1.5618-1.259,2.8279-2.8121,2.8279 c-1.5531,0-2.8121-1.2661-2.8121-2.8279V30.5734c0-1.5618,1.259-2.8279,2.8121-2.8279c1.5531,0,2.8121,1.2661,2.8121,2.8279 V53.1003z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverall);
export default __webpack_public_path__ + "static/media/overall.7d6ea413b2a93893d38b427d2bf9d3e7.svg";
export { ForwardRef as ReactComponent };